import axios from "axios";
import { EventBus } from "@/main";

export default class Csv {
	constructor(data) {
		this.data = data ? data : null;

		this.endPoint = `${process.env.VUE_APP_API_SERVER}/export`;
	}

	async toCsv(config = {mapType: 'default', fileName: null}) {
		try {
			let response = await axios.post(
				this.endPoint,
				{
					data: this.data,
					...config
				}
			);

			this.downloadUrl = response.data.data.downloadUrl
		} catch (error) {
			throw error;
		}
	}

	async jsonToCsv(config = {}) {
	
		try {
			let response = await axios.post(
				this.endPoint,
				{
					data: this.data,
					name: config.filename
				}
			);

			this.downloadUrl = response.data.data.downloadUrl
		} catch (error) {
			throw error;
		}
	}

	async arrayToCsv(config = {}) {
		try {
			let response = await axios.post(
				this.endPoint,
				{
					data: this.data,
					name: config.filename
				}
			);

			this.downloadUrl = response.data.data.downloadUrl
		} catch (error) {
			throw error;
		}
	}

	async csvToJson(csv_file) {
		try {
			let formData = new FormData();

			formData.append("file", csv_file);

			let response = await axios.post(
				`${process.env.VUE_APP_API_SERVER}/csvtoarray`,
				formData
			);

			return response.data.data;
		} catch (error) {
			throw error;
		}
	}

	csvDownload(){
		window.open(this.downloadUrl)
	}
}
